var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgType3C(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;}.b,.d{fill:#c8d1ec;}.c,.f{fill:#fff;}.e,.f{stroke:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 74,
    height: 74,
    rx: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 11)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 32,
    height: 52,
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 28,
    height: 48,
    rx: 14,
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 24,
    height: 44,
    rx: 12,
    transform: "translate(4 4)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(6.078 15.474)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 4 7.25 C 2.207940101623535 7.25 0.75 5.792059898376465 0.75 4 C 0.75 2.207940101623535 2.207940101623535 0.75 4 0.75 C 5.792059898376465 0.75 7.25 2.207940101623535 7.25 4 C 7.25 5.792059898376465 5.792059898376465 7.25 4 7.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 4 1.5 C 2.621500015258789 1.5 1.5 2.621500015258789 1.5 4 C 1.5 5.378499984741211 2.621500015258789 6.5 4 6.5 C 5.378499984741211 6.5 6.5 5.378499984741211 6.5 4 C 6.5 2.621500015258789 5.378499984741211 1.5 4 1.5 M 4 0 C 6.209139823913574 0 8 1.790860176086426 8 4 C 8 6.209139823913574 6.209139823913574 8 4 8 C 1.790860176086426 8 0 6.209139823913574 0 4 C 0 1.790860176086426 1.790860176086426 0 4 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(6.078 28.474)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 4 7.25 C 2.207940101623535 7.25 0.75 5.792059898376465 0.75 4 C 0.75 2.207940101623535 2.207940101623535 0.75 4 0.75 C 5.792059898376465 0.75 7.25 2.207940101623535 7.25 4 C 7.25 5.792059898376465 5.792059898376465 7.25 4 7.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 4 1.5 C 2.621500015258789 1.5 1.5 2.621500015258789 1.5 4 C 1.5 5.378499984741211 2.621500015258789 6.5 4 6.5 C 5.378499984741211 6.5 6.5 5.378499984741211 6.5 4 C 6.5 2.621500015258789 5.378499984741211 1.5 4 1.5 M 4 0 C 6.209139823913574 0 8 1.790860176086426 8 4 C 8 6.209139823913574 6.209139823913574 8 4 8 C 1.790860176086426 8 0 6.209139823913574 0 4 C 0 1.790860176086426 1.790860176086426 0 4 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(18.078 15.474)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 4 7.25 C 2.207940101623535 7.25 0.75 5.792059898376465 0.75 4 C 0.75 2.207940101623535 2.207940101623535 0.75 4 0.75 C 5.792059898376465 0.75 7.25 2.207940101623535 7.25 4 C 7.25 5.792059898376465 5.792059898376465 7.25 4 7.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 4 1.5 C 2.621500015258789 1.5 1.5 2.621500015258789 1.5 4 C 1.5 5.378499984741211 2.621500015258789 6.5 4 6.5 C 5.378499984741211 6.5 6.5 5.378499984741211 6.5 4 C 6.5 2.621500015258789 5.378499984741211 1.5 4 1.5 M 4 0 C 6.209139823913574 0 8 1.790860176086426 8 4 C 8 6.209139823913574 6.209139823913574 8 4 8 C 1.790860176086426 8 0 6.209139823913574 0 4 C 0 1.790860176086426 1.790860176086426 0 4 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(18.078 28.474)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 4 7.25 C 2.207940101623535 7.25 0.75 5.792059898376465 0.75 4 C 0.75 2.207940101623535 2.207940101623535 0.75 4 0.75 C 5.792059898376465 0.75 7.25 2.207940101623535 7.25 4 C 7.25 5.792059898376465 5.792059898376465 7.25 4 7.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 4 1.5 C 2.621500015258789 1.5 1.5 2.621500015258789 1.5 4 C 1.5 5.378499984741211 2.621500015258789 6.5 4 6.5 C 5.378499984741211 6.5 6.5 5.378499984741211 6.5 4 C 6.5 2.621500015258789 5.378499984741211 1.5 4 1.5 M 4 0 C 6.209139823913574 0 8 1.790860176086426 8 4 C 8 6.209139823913574 6.209139823913574 8 4 8 C 1.790860176086426 8 0 6.209139823913574 0 4 C 0 1.790860176086426 1.790860176086426 0 4 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2.384,0A2.384,2.384,0,1,1,0,2.384,2.384,2.384,0,0,1,2.384,0Z",
    transform: "translate(13.616 39.616)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.587,0A1.587,1.587,0,1,1,0,1.587,1.587,1.587,0,0,1,1.587,0Z",
    transform: "translate(19.413 8.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.84,0A.84.84,0,1,1,0,.84.84.84,0,0,1,.84,0Z",
    transform: "translate(15.16 41.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.587,0A1.587,1.587,0,1,1,0,1.587,1.587,1.587,0,0,1,1.587,0Z",
    transform: "translate(9.413 8.413)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2,
    height: 3,
    rx: 1,
    transform: "translate(19 24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2,
    height: 3,
    rx: 1,
    transform: "translate(12 24)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType3C);
export default __webpack_public_path__ + "static/media/type3c.2945460f9cb12f3097ceef8bbdf0e053.svg";
export { ForwardRef as ReactComponent };